import { Card, Col, Container, Row } from 'react-bootstrap';
import { motion } from "motion/react";
import marketData from '../../data/marketData.json';

const Deliverables = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.2 }
    }
  }

  const cardVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.5, ease: "easeOut" }
    }
  }

  return (
    <section className="section-lg bg-light overflow-hidden" id="growth-services">
      <Container>
        <Row>
          <Col xs={12} className='mb-5'>
            <motion.h6 initial={{ opacity: 0, y: -30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 1, ease: 'linear', delay: 0.1 }} className="underline-after position-relative text-center z-0">
              <span className="position-relative z-1 bg-white text-primary px-3">Insights We Deliver</span>
            </motion.h6>
            <motion.h1 initial={{ opacity: 0, scale: 0 }} whileInView={{ opacity: 1, scale: 1 }} viewport={{ once: true }} transition={{ duration: 1, ease: 'linear', delay: 0.1 }} className="d-block text-gradiant text-center fw-semibold">From opportunity sizing to positioning</motion.h1>
          </Col>
        </Row>
        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
        >
          <Row className="g-4">
            {marketData.deliverables.map((deliverable) => (
              <Col md={6} lg={4} key={deliverable.id}>
                <motion.div variants={cardVariants}
                  whileHover={{ y: -8, transition: { duration: 0.3 } }}
                >
                  <Card className="h-100">
                    <Card.Body className="p-4">
                      <div className="d-flex align-items-center mb-2">
                        <span className={`icon-badge rounded-circle bg-${deliverable.iconBg}-subtle text-${deliverable.iconBg} d-inline-flex align-items-center justify-content-center me-2`} style={{width: '44px', height: '44px'}}>
                          <i className={`${deliverable.icon} fs-5`}></i>
                        </span>
                        <h5 className="mb-0">{deliverable.title}</h5>
                      </div>
                      <p className="text-secondary mb-2">{deliverable.description}</p>
                      <ul className="list-unstyled lh-lg small mb-0">
                        {deliverable.items.map((item, idx) => (
                          <motion.li key={idx} className="d-flex align-items-center"
                            initial={{ opacity: 0, x: -10 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            viewport={{ once: true }}
                            transition={{ delay: idx * 0.1 + 0.3 }}
                          >
                            <i className="ri-checkbox-circle-line text-success me-2"></i> {item}
                          </motion.li>
                        ))}
                      </ul>
                    </Card.Body>
                  </Card>
                </motion.div>
              </Col>
            ))}
          </Row>
        </motion.div>
      </Container>
    </section>
  )
}

export default Deliverables;
